import axios from "axios";

const http = axios.create({
  baseURL: process.env.VUE_APP_SEARCH_API_BASE
});

function getEnterpriseObjects() {
  return http.get("/manage/getAvailableObjects").then(res => {
    return res.data;
  });
}

export default {
  getEnterpriseObjects
};
